"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
var react_1 = __importStar(require("react"));
var constants_1 = require("../../../constants");
var radio_1 = require("../../../constants/atoms/radio");
var mixpanel_events_1 = require("../../../constants/mixpanel-events");
var RADIO_STATE_STYLES = (_a = {},
    _a[radio_1.RADIO_TYPES.SELECTED] = (_b = {},
        _b[radio_1.RADIO_STATE_TYPES.ENABLED] = 'tw-cursor-pointer tw-border-TEXT_PRIMARY',
        _b[radio_1.RADIO_STATE_TYPES.HOVER] = 'hover:tw-bg-white hover:tw-ring-[14px] hover:tw-ring-LIGHT_PRIMARY_1',
        _b[radio_1.RADIO_STATE_TYPES.PRESSED] = 'active:tw-bg-TEXT_PRIMARY hover:tw-ring-LIGHT_PRIMARY_2',
        _b[radio_1.RADIO_STATE_TYPES.DISABLED] = 'tw-cursor-not-allowed tw-border-DIVIDER_GRAY tw-bg-white',
        _b),
    _a[radio_1.RADIO_TYPES.UNSELECTED] = (_c = {},
        _c[radio_1.RADIO_STATE_TYPES.ENABLED] = 'tw-cursor-pointer tw-border-DIVIDER_GRAY tw-bg-white',
        _c[radio_1.RADIO_STATE_TYPES.HOVER] = 'hover:tw-bg-white hover:tw-border-TEXT_PRIMARY hover:tw-ring-[14px] hover:tw-ring-LIGHT_PRIMARY_1',
        _c[radio_1.RADIO_STATE_TYPES.PRESSED] = 'active:tw-bg-TEXT_PRIMARY hover:tw-ring-LIGHT_PRIMARY_2',
        _c[radio_1.RADIO_STATE_TYPES.DISABLED] = 'tw-cursor-not-allowed tw-border-DIVIDER_GRAY tw-bg-BASE_PRIMARY',
        _c),
    _a);
var Radio = function (_a) {
    var _b = _a.wrapperClassName, wrapperClassName = _b === void 0 ? 'tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-rounded-full tw-z-10' : _b, _c = _a.radioClassName, radioClassName = _c === void 0 ? 'tw-w-5 tw-h-5 tw-rounded-full tw-z-20' : _c, _d = _a.radioSelectedClassName, radioSelectedClassName = _d === void 0 ? 'tw-border-[7px]' : _d, _e = _a.radioDefaultClassName, radioDefaultClassName = _e === void 0 ? 'tw-border' : _e, _f = _a.wrapperStyle, wrapperStyle = _f === void 0 ? '' : _f, _g = _a.radioStyle, radioStyle = _g === void 0 ? '' : _g, _h = _a.radioSelectedStyle, radioSelectedStyle = _h === void 0 ? '' : _h, _j = _a.radioDefaultStyle, radioDefaultStyle = _j === void 0 ? '' : _j, _k = _a.checked, checked = _k === void 0 ? false : _k, _l = _a.isDisabled, isDisabled = _l === void 0 ? false : _l, _m = _a.onSelect, onSelect = _m === void 0 ? constants_1.defaultFn : _m, _o = _a.isClearable, isClearable = _o === void 0 ? true : _o, id = _a.id, eventCallback = _a.eventCallback;
    var _p = react_1.useState(checked), isSelected = _p[0], setIsSelected = _p[1];
    var stateStyles = isSelected
        ? RADIO_STATE_STYLES[radio_1.RADIO_TYPES.SELECTED]
        : RADIO_STATE_STYLES[radio_1.RADIO_TYPES.UNSELECTED];
    var radioStylesByState = isDisabled
        ? stateStyles[radio_1.RADIO_STATE_TYPES.DISABLED]
        : stateStyles[radio_1.RADIO_STATE_TYPES.ENABLED] + " " + stateStyles[radio_1.RADIO_STATE_TYPES.HOVER] + " " + stateStyles[radio_1.RADIO_STATE_TYPES.PRESSED];
    react_1.useEffect(function () {
        setIsSelected(function (isSelected) { return (checked !== isSelected ? checked : isSelected); });
    }, [checked]);
    var handleSelect = function () {
        if (!isDisabled) {
            var currentStatus = !isSelected;
            setIsSelected(currentStatus);
            onSelect(currentStatus);
            eventCallback === null || eventCallback === void 0 ? void 0 : eventCallback(mixpanel_events_1.mixpanelEvents.RADIO_CLICK, { id: id, currentStatus: currentStatus });
        }
    };
    return (react_1.default.createElement("div", { className: wrapperClassName + " " + wrapperStyle, "data-testid": "radio-wrapper-" + id },
        react_1.default.createElement("div", { "data-testid": "radio-" + id, role: 'presentation', className: radioStylesByState + " " + radioClassName + " " + radioStyle + " " + (isSelected
                ? radioSelectedClassName + " " + radioSelectedStyle
                : radioDefaultClassName + " " + radioDefaultStyle), onClick: isClearable || !isSelected ? handleSelect : constants_1.defaultFn })));
};
exports.Radio = Radio;
